import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { liveCleanroom } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-query';


export const useToggleDatasetLiveCr = (crId) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);

  return useMutation(
    async ({ datasetId, body }) => {
      const { data } = await axiosInstance.post(liveCleanroom(orgId)
        .enableDataset(crId, datasetId), body);
      return data;
    },
    {
      onSuccess: () => {
        dispatch(showAlert({ message: 'Dataset toggled successfully', type: 'success' }));
      },
      onError: (error) => {
        dispatch(showAlert({
          message: error.response?.data?.message ?? 'Error toggling dataset',
          type: 'error',
        }));
      },
    },
  );
};
